export default __webpack_public_path__ + "static/flag-ee-38e2478bbddd5363f08afd2bddc88553.svg";